var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ color: _vm.color })},[_vm._v("\n  "+_vm._s(_vm.renderCell(_vm.type, _vm.value))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }